import React from 'react'

const Paragrafo = ({children}) => {
    return (
        <p>{children}</p>
    )
}

export default Paragrafo